import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type ExternalContentCardFragment = { id: string, name: string, type: Types.ResourceTypeEnum, duration: number, description?: string | null, status: Types.ResourceStatusEnum, objective?: string | null, externalContentType?: Types.ExternalContentTypeEnum | null, cover?: { name: string, url?: string | null, size?: number | null, mimeType?: string | null, mediaId: string, kind: Types.MediaKindEnum } | null, provider?: { id: string, name: string, url: string, logo: { name: string, url?: string | null, size?: number | null, mimeType?: string | null, mediaId: string, kind: Types.MediaKindEnum } } | null, performance?: { id: string, status: Types.PerformanceStatusEnum, progress: number, estimatedTimeSpent?: number | null } | null, bookmark?: { id: string } | null };


export type ExternalContentCardFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export type ExternalContentCardWithUserPerformanceFragment = { id: string, name: string, type: Types.ResourceTypeEnum, duration: number, description?: string | null, status: Types.ResourceStatusEnum, objective?: string | null, externalContentType?: Types.ExternalContentTypeEnum | null, cover?: { name: string, url?: string | null, size?: number | null, mimeType?: string | null, mediaId: string, kind: Types.MediaKindEnum } | null, provider?: { id: string, name: string, url: string, logo: { name: string, url?: string | null, size?: number | null, mimeType?: string | null, mediaId: string, kind: Types.MediaKindEnum } } | null, performance?: { id: string, status: Types.PerformanceStatusEnum, estimatedTimeSpent?: number | null, enrolmentInfo?: { dueDate?: string | null } | null } | null, bookmark?: { id: string } | null };


export type ExternalContentCardWithUserPerformanceFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const ExternalContentCardFragmentDoc = /*#__PURE__*/ gql`
    fragment ExternalContentCard on ExternalContentType {
  id
  name
  type
  duration
  description
  status
  objective
  cover {
    name
    url
    size
    mimeType
    mediaId
    kind
  }
  externalContentType
  provider {
    id
    name
    logo {
      name
      url
      size
      mimeType
      mediaId
      kind
    }
    url
  }
  performance {
    id
    status
    progress
    estimatedTimeSpent
  }
  bookmark {
    id
  }
}
    `;
export const ExternalContentCardWithUserPerformanceFragmentDoc = /*#__PURE__*/ gql`
    fragment ExternalContentCardWithUserPerformance on ExternalContentType {
  id
  name
  type
  duration
  description
  status
  objective
  cover {
    name
    url
    size
    mimeType
    mediaId
    kind
  }
  externalContentType
  provider {
    id
    name
    logo {
      name
      url
      size
      mimeType
      mediaId
      kind
    }
    url
  }
  performance(userId: $userId) {
    id
    status
    estimatedTimeSpent
    enrolmentInfo {
      dueDate
    }
  }
  bookmark {
    id
  }
}
    `;